const EXPLORE = [
  { href: "#live", label: "正在热播" },
  { href: "#rank", label: "吃瓜热榜" },
  { href: "#hosts", label: "人气主播" },
  { href: "#steps", label: "新手教程" },
  { href: "#faq", label: "常见问题" },
];

const PLAY = [
  { href: "#features", label: "高清连麦" },
  { href: "#features", label: "实时弹幕" },
  { href: "#features", label: "礼物打赏" },
  { href: "#features", label: "精彩回放" },
  { href: "#join", label: "订阅开播提醒" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜快手返回顶部">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 text-xl font-bold text-background-50">
                瓜
              </span>
              <span className="leading-none">
                <span className="block text-lg font-bold text-foreground-950">吃瓜快手</span>
                <span className="font-accent-latin text-[11px] text-primary-600">Chigua Live</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              高清连麦、实时弹幕、礼物打赏、精彩回放一应俱全的直播吃瓜互动专区，让每一次围观都变成现场。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="#join"
                aria-label="订阅开播提醒"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-foreground-700 transition hover:bg-primary-500 hover:text-foreground-950"
              >
                <i className="ri-notification-3-line" />
              </a>
              <a
                href="mailto:hello@chiguakuaishou.example"
                aria-label="邮箱联系"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-foreground-700 transition hover:bg-primary-500 hover:text-foreground-950"
              >
                <i className="ri-mail-line" />
              </a>
              <a
                href="#live"
                aria-label="进入直播间"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-foreground-700 transition hover:bg-primary-500 hover:text-foreground-950"
              >
                <i className="ri-live-line" />
              </a>
            </div>
          </div>

          <nav aria-label="探索吃瓜快手">
            <h3 className="text-sm font-bold text-foreground-950">探索现场</h3>
            <ul className="mt-4 space-y-2.5">
              {EXPLORE.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-foreground-600 transition hover:text-primary-600">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="平台玩法">
            <h3 className="text-sm font-bold text-foreground-950">玩法互动</h3>
            <ul className="mt-4 space-y-2.5">
              {PLAY.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-foreground-600 transition hover:text-primary-600">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">与我们联系</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              开播合作 / 意见反馈 / 社区建议，欢迎随时来信：
            </p>
            <a
              href="mailto:hello@chiguakuaishou.example"
              className="mt-3 inline-flex items-center gap-2 rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-primary-700 transition hover:border-primary-300"
            >
              <i className="ri-mail-send-line" /> hello@chiguakuaishou.example
            </a>
            <p className="mt-4 text-xs leading-5 text-foreground-500">
              服务时间：每日 09:00 - 23:00
              <br />
              全时段均有客服轮值为你答疑。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜快手 Chigua Live · 让每一次围观都变成现场
          </p>
          <p className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" className="transition hover:text-primary-600">帮助中心</a>
            <span className="h-3 w-px bg-background-300"></span>
            <a href="#join" className="transition hover:text-primary-600">联系我们</a>
          </p>
        </div>
      </div>
    </footer>
  );
}